import { getPostNum } from "../../../../constant/General";
import React from "react";

const RenderPosA = ({ posts, field = "twoD", config }) => {
    const style = config.ng[`post_a_${field}`];
    const styleHeight = config.ng[`height_a_${field}`];
    const styleMl = config.ng.ml_a;
    return <div style={style} className="d-flex justify-content-start align-items-center post">
        {posts.map((post, i) => {
            return <div
                style={i === 0 ? { ...styleHeight, ...styleMl } : styleHeight}
                className="d-flex justify-content-center align-items-center" key={i}>
                <div className="scale-text">{getPostNum(post[field])}</div>
            </div>
        })}
    </div>
}


function ResultTable({ post, config }) {

    return (<div style={{
        backgroundImage: `url(${require(`../../../../assets/images/live-v2/${config.type}/ng/bg.png`)})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
    }} className="w-50 d-flex justify-content-center align-items-center position-relative">
        <div className="position-relative">
            <img height="750" className="w-100"
                src={require(`../../../../assets/images/live-v2/${config.type}/ng/post.png`)}
                alt="__" />

            <div className="position-absolute w-100 h-100" style={{ top: 0, left: 0 }}>
                <div style={{ marginTop: "121px" }}>
                    <RenderPosA
                        config={config}
                        posts={post.postA2D}
                    />
                    <RenderPosA
                        config={config}
                        posts={post.postA3D}
                        field="threeD"
                    />
                </div>

                <div style={{ fontSize: "80px", marginLeft: "284px", color: "#FEDC00" }} className=" post">
                    {post.postBCD.map((post, i) => {
                        return <div
                            style={i === 0 ? { height: "112px", marginTop: "24px" } : { height: "112px", marginTop: "14px" }}
                            className="d-flex justify-content-start align-items-center" key={i}>
                            <div className="scale-text" style={config.ng.post_bcd}>{getPostNum(post.twoD)}</div>
                            <div className="scale-text" style={config.ng.post_bcd}>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </div>);
}

export default ResultTable;